import { useEffect } from 'react';
import { useTourIntentContext } from '../context/TourIntentContext';

// Runs `handler` when an intent addressed to `componentName` arrives, then clears it
export const useTourIntent = (componentName, handler) => {
  const context = useTourIntentContext();

  useEffect(() => {
    if (!context?.intent || context.intent.component !== componentName) return;
    handler(context.intent);
    context.clearIntent();
  }, [context, componentName, handler]);
};
